import React from "react";
import styled from "@emotion/styled";
import { Link } from "@reach/router";
import { BigPrimaryButton } from "../primitives/Buttons";
import Logo from "./Logo";
import CurrentUserActions from "./CurrentUserActions";
import { useCurrentUserContext } from "../../hooks/useCurrentUser";
import useLocation from "../../hooks/core/useLocation";
import { redirectToLogin } from "../../auth/auth";

function Nav() {
  let { user, isLoggedIn } = useCurrentUserContext();
  let currentUser = user && user.username ? user.username.toLowerCase() : "";
  return (
    <StyledNav>
      <div className="nav-left">
        <Logo />
        <div className="nav-links left">
          {currentUser && <NavLink path={`/${currentUser}`}>My Snippets</NavLink>}
          <NavLink path="/docs/vscode">How To</NavLink>
          <NavLink path="/explore">Explore</NavLink>
        </div>
      </div>
      <div className="nav-right nav-links">
        {currentUser && isLoggedIn && (
          <Link to="/new-snippet" title="Create a new Code Snippet">
            <BigPrimaryButton>+Add Snippet</BigPrimaryButton>
          </Link>
        )}
        {!isLoggedIn && (
          <BigPrimaryButton onClick={() => redirectToLogin()}>Login w/ Github</BigPrimaryButton>
        )}
        <CurrentUserActions />
      </div>
    </StyledNav>
  );
}
export default React.memo(Nav);

const StyledNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  text-transform: uppercase;
  padding: 10px 10px;
  font-family: var(--monospace);
  background: ${(props) => props.theme.blackBackground};
  height: 57px;
  box-sizing: border-box;
  .nav-left,
  .nav-right {
    display: flex;
    align-items: center;
  }
  .nav-links {
    display: flex;
    align-items: center;
    > a {
      margin-right: 10px;
      padding: 5px 10px;
      color: var(--light);
      text-decoration: none;
      border-bottom: 2px solid transparent;
    }
    > a.active {
      color: var(--white);
      border-bottom-color: var(--primary);
    }
  }
`;

export const checkIsActive = (location, path) => {
  // Current window.location.pathname must start with NavLink path
  return location.pathname.toLowerCase().indexOf(path.toLowerCase()) === 0;
};

export const NavLink = ({ path, children }) => {
  let location = useLocation();
  let cssClass = ["link", checkIsActive(location, path) ? "active" : ""].filter((c) => c).join(" ");
  return (
    <Link className={cssClass} to={path}>
      {children}
    </Link>
  );
};
